import { normalizeString } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import {
  serializeNodes,
  serializeNodesToText,
} from '@plone/volto-slate/editor/render';
import Slugger from 'github-slugger';
import isEqual from 'lodash/isEqual';

const TextBlockView = (props) => {
  const { id, data, styling = {} } = props;
  const { value, override_toc, legacyNodeIds = {} } = data;
  const metadata = props.metadata || props.properties;
  const { topLevelTargetElements } = config.settings.slate;

  const getAttributes = (node, path) => {
    const res = {
      ...styling,
      ...(node.textAlign
        ? { style: { ...(styling.style || {}), textAlign: node.textAlign } }
        : {}),
    };

    if (node.type) {
      const zeroBasedPath = (path || []).join('.');
      const oneBasedPath = (path || []).map((segment) => segment + 1).join('.');

      const mappedNodeId =
        legacyNodeIds[zeroBasedPath] || legacyNodeIds[oneBasedPath];

      if (mappedNodeId) {
        res.id = mappedNodeId;
      }
    }

    if (node.type && isEqual(path, [0])) {
      if (
        !res.id &&
        (topLevelTargetElements.includes(node.type) || override_toc)
      ) {
        const text = serializeNodesToText(node?.children || []);
        const slug = Slugger.slug(normalizeString(text));
        res.id = slug || id;
      }
    }
    return res;
  };

  return serializeNodes(value, getAttributes, { metadata: metadata });
};

export default TextBlockView;
